"use client";

import * as stylex from "@stylexjs/stylex";
import type { GeneralsReplay } from "./generals/generals-board-model";
import { useGeneralsBoard } from "./generals/use-generals-board";

const replayFadeMs = 900;

// Direct tile updates keep replay animation outside React's render cycle.
export function GeneralsBoard({
  replays,
  size = 416,
}: {
  readonly replays: readonly (GeneralsReplay | null)[];
  readonly size?: number;
}) {
  const ref = useGeneralsBoard({ replays, size, replayFadeMs });
  return (
    <div
      ref={ref}
      aria-hidden="true"
      data-generals-board="replay"
      {...stylex.props(styles.board, styles.size(size))}
    />
  );
}
const styles = stylex.create({
  board: { display: "grid", transition: `opacity ${replayFadeMs}ms ease` },
  size: (size: number) => ({ width: size, height: size }),
});
